import React, { Context } from 'react';
import { AppContext, AppContextInterface } from '../app-context-provider';
import { PageItem } from '../components/component-switcher';
import Img from './Img';

export interface PhotoComponentProps extends PageItem {
  styleTags: string[];
  url: string;
  id: number;
  altText: string;
  selected: boolean;
  onClick: any;
  originalImage: any;
}

export interface PhotoComponentState {}

class PhotoComponent extends React.PureComponent<
  PhotoComponentProps,
  PhotoComponentState
> {
  static contextType: Context<AppContextInterface | null> = AppContext;
  public context!: AppContextInterface;
  state: PhotoComponentState = {};

  render() {
    if (!this.props.url) {
      return null;
    }
    return (
      <div
        key={this.props.originalImage?.key}
        className='photo-component'
        onClick={() => this.props.onClick(this.props.id)}>
        <Img
          className='item-image-container'
          src={this.props.originalImage?.url}
          alt={`${this.props.originalImage?.altText}`}
        />
        {!this.props.hideTitle && <h4>{this.props.title}</h4>}
        <div
          dangerouslySetInnerHTML={{ __html: this.props.description }}
          className='item-image-text'
        />
        {/* <PhotoDownloadOptions { ...this.props } /> */}
      </div>
    );
  }
}

export default PhotoComponent;
